import React from 'react';

export const ToShopInfo = () => {
    return (
        <div className="text-grey-1 text-sm ml-5 mt-2.5">
            <ul className="list-disc">
                <li className="sm:mb-1 mb-1.5">
                    <strong className="pr-1">To Shop Online:</strong>This eGift Card balance must be
                    equal to or greater than the purchase total.
                </li>
                <li>
                    <strong className="pr-1">To Shop In-Store:</strong>This eGift Card must be added
                    to a mobile device’s digital wallet (Apple, Google, Samsung).
                </li>
            </ul>
        </div>
    );
};
